import Socialshare from "../../../../components/socialShare"
import { useAppSelector } from "../../../../store/hooks"

const Socialvernfonk = () => {
  const { detail } = useAppSelector(state => state.campaign)
  return (
    <>
      <div className="c-code-qr">
        <Socialshare
          title="Save up to 20%"
          url={detail.social_post_auto_1}
          textButton="Download Image"
          nameFile="social_1"
        />
        <Socialshare
          title="Switch and Save up to 20%"
          url={detail.social_post_auto_2}
          textButton="Download Image"
          nameFile="social_2"
        />
      </div>
      <div className="c-code-qr">
        <Socialshare
          title="Switch and Save up to 20%"
          url={detail.social_post_auto_3}
          textButton="Download Image"
          nameFile="social_1"
        />
      </div>
    </>
  )
}

export default Socialvernfonk